// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact_container__3z7g0","box":"Contact_box__1_jpH","topHeader":"Contact_topHeader__2LO_f","backIcon":"Contact_backIcon__2tzwh","row":"Contact_row__1G4XN"};